import React, { useState, useRef, useEffect } from 'react';
import { Menu, User, Settings, LogOut, ChevronDown } from 'lucide-react';
import { Link } from 'react-router-dom';
// import Settings from './Settings';
// import JobScheduler from '../JobScheduler/JobScheduler';
import './Navbar.css';

const Navbar = ({
  title,
  onToggleSidebar,
  admin,
  onLogout,
  onProfileClick,
  onSettingsClick
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    setDropdownOpen(false);
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    if (onLogout) {
      onLogout();
    }
  };

  // const handleNavigation = (path) => {
  //   navigate(`/admin/${path}`);
  // };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // Get admin display name
  const getAdminDisplayName = () => {
    if (!admin) return 'Admin User';
    return admin.fullName || admin.username || 'Admin User';
  };

  // Get admin email
  const getAdminEmail = () => {
    if (!admin) return 'admin@immigration.com';
    return admin.email || 'admin@immigration.com';
  };

  // Get admin avatar
  const getAdminAvatar = () => {
    if (admin?.avatar) {
      return admin.avatar;
    }
    // Generate a consistent color based on name
    const name = getAdminDisplayName();
    const colors = [
      'linear-gradient(135deg, #3b82f6, #1d4ed8)',
      'linear-gradient(135deg, #10b981, #059669)',
      'linear-gradient(135deg, #f59e0b, #d97706)',
      'linear-gradient(135deg, #8b5cf6, #7c3aed)',
      'linear-gradient(135deg, #ef4444, #dc2626)'
    ];
    const colorIndex = name.charCodeAt(0) % colors.length;
    return { initial: name.charAt(0).toUpperCase(), gradient: colors[colorIndex] };
  };

  const avatarData = getAdminAvatar();

  return (
    <nav className="admin-navbar">
      <div className="admin-navbar-left">
        
        <h1 className="admin-navbar-title">{title}</h1>
      </div>

      <div className="admin-navbar-profile-section" ref={dropdownRef}>
        <button className="admin-navbar-profile-button" onClick={toggleDropdown}>
          {typeof avatarData === 'string' ? (
            <img src={avatarData} alt="Admin" className="admin-navbar-avatar" />
          ) : (
            <div className="admin-navbar-avatar admin-navbar-avatar-generated" style={{ background: avatarData.gradient }}>
              {avatarData.initial}
            </div>
          )}
          <div className="admin-navbar-profile-info">
            <div className="admin-navbar-profile-name">{getAdminDisplayName()}</div>
            <div className="admin-navbar-profile-email">{getAdminEmail()}</div>
          </div>
          <ChevronDown size={16} className={`admin-navbar-dropdown-arrow ${dropdownOpen ? 'open' : ''}`} />
        </button>

       {dropdownOpen && (
          <div className="admin-navbar-dropdown">
            <Link to="/admin/profile" className="admin-navbar-dropdown-item" onClick={() => setDropdownOpen(false)}>
              <User size={16} />
              My Profile
            </Link>
            
            {/* 4. CHANGE THE BUTTON TO A LINK */}
            <Link to="/admin/settings" className="admin-navbar-dropdown-item" onClick={() => setDropdownOpen(false)}>
              <Settings size={16} />
              Settings
            </Link>

            <div className="admin-navbar-dropdown-divider"></div>
            <button className="admin-navbar-dropdown-item admin-navbar-logout-item" onClick={handleLogout}>
              <LogOut size={16} />
              Logout
            </button>
          </div>
        )}
      </div>

      {dropdownOpen && (
        <div className="admin-navbar-dropdown-overlay" onClick={() => setDropdownOpen(false)} />
      )}
    </nav>

  );
};

export default Navbar;
